<template>
  <div class="app-container">
    <el-tabs v-model="activeName" >
      <el-tab-pane label="作业记录" name="one" style="">
        <shangban v-if="activeName=='one'"></shangban>
      </el-tab-pane>
      <el-tab-pane label="请假记录" name="two">
        <qingjia v-if="activeName=='two'"></qingjia>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import shangban from '@/views/vgs-driver2.0/ziyouyunli/driverAttendance/shangban.vue'
import qingjia from '@/views/vgs-driver2.0/ziyouyunli/driverAttendance/qingjia.vue'
export default {
  components: {
    shangban,
    qingjia
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {

  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
